module.exports = __webpack_public_path__ + "img/ats-l-n1.78353805.gif";